import { render, staticRenderFns } from "./locomotive.vue?vue&type=template&id=587c86e6&"
import script from "./locomotive.vue?vue&type=script&lang=js&"
export * from "./locomotive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports